import React from 'react';
import { createFormFields } from './create-form-fields';
import { Grid } from '../grid/grid';
import { FormViewContext } from '../../../../contexts/form-view-context';
import { UniqueFieldSuffixContextProvider } from '../../../../contexts/unique-field-suffix-context';
import { DefaultFieldLayout } from '../../../../field-layout';
import { useConfig } from '../../../../contexts/config-context';
const FormRoot = _ref => {
  let {
    form,
    values,
    onFieldChange,
    errors,
    formSchema,
    validateFields,
    fields,
    fieldActions
  } = _ref;
  const {
    isRTL
  } = useConfig();
  const formFields = createFormFields({
    form,
    values,
    onFieldChange,
    errors,
    FieldLayout: DefaultFieldLayout,
    formSchema,
    validateFields,
    fields,
    fieldActions
  });
  return /*#__PURE__*/React.createElement(Grid, {
    isRTL: isRTL,
    items: formFields,
    layout: form.grid
  });
};
export const Form = props => {
  return /*#__PURE__*/React.createElement(FormViewContext.Provider, {
    value: props.form
  }, /*#__PURE__*/React.createElement(UniqueFieldSuffixContextProvider, {
    parentId: props.form.parentId
  }, /*#__PURE__*/React.createElement(FormRoot, props)));
};
//# sourceMappingURL=form.js.map